export default __webpack_public_path__ + "static/media/Johannes_sur.3d9457bf.jpg";